/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
import { useMutation } from "@tanstack/react-query";
import { updateSubscription } from "./queryFunctions";
import { queryClient } from "@/utils/queryClient";
import { message } from "antd";

export const useUpdateSubscription = () => {
  return useMutation({
    mutationKey: ['update-subscription'],
    mutationFn: updateSubscription,
    onSuccess: async (data, context) => {
      // Simulate a delay of 3 seconds
      await new Promise((resolve) => setTimeout(resolve, 3000));
      queryClient.invalidateQueries({
        queryKey: ["project", context.projectId],
      });
      message.open({
        type: 'success',
        content: "Subscription updated successfully.",
        duration: 5,
        style: { fontFamily: 'Ubuntu' }
      });
      queryClient.invalidateQueries({ queryKey: ["user-info"] });

      return data;
    },
    onError: () => {
      message.open({
        type: 'error',
        content: "An error occurred. Please try again later.",
        duration: 5,
        style: { fontFamily: 'Ubuntu' }
      });
    }
  });
};
